export default __webpack_public_path__ + "static/media/login.65178453.jpg";